const workRouter = [
  {
      path: "list-factory",
      name: "factory",
      component: () => import("@/views/admin/factory"),
      default: true,
      meta: {
          model: "factory",
          // requiresAuth: true,
      },
  },
  {
      path: "list-factory/add",
      name: "addFactory",
      component: () => import("@/views/admin/factory/function"),
      default: true,
      meta: {
          model: "factory",
          // requiresAuth: true,
      },
  },
  {
      path: "list-factory/edit/:id",
      name: "editFactory",
      component: () => import("@/views/admin/factory/function"),
      default: true,
      meta: {
          model: "factory",
          // requiresAuth: true,
      },
  },
];
export default workRouter;